import { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export function useAuthStatus() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(true);

  useEffect(() => {
    console.log('🔍 useAuthStatus: Starting check...');
    const auth = getAuth();
    
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        console.log('✅ useAuthStatus: User logged in:', user.email);
        setLoggedIn(true);
        
        // Check if user is admin
        try {
          const docRef = doc(db, 'users', user.uid);
          const docSnap = await getDoc(docRef);
          
          if (docSnap.exists()) {
            const userData = docSnap.data();
            const adminStatus = userData.role === 'admin' || userData.isAdmin === true;
            setIsAdmin(adminStatus);
            console.log('🔐 Admin status:', adminStatus);
            console.log('🔐 User role:', userData.role);
            console.log('🔐 User isAdmin:', userData.isAdmin);
          }
        } catch (error) {
          console.error('Error checking admin status:', error);
          setIsAdmin(false);
        }
      } else {
        console.log('❌ useAuthStatus: No user');
        setLoggedIn(false);
        setIsAdmin(false);
      }
      
      setCheckingStatus(false);
      console.log('🔍 useAuthStatus: Check complete. Logged in:', !!user);
    });

    return unsubscribe;
  }, []);

  return { loggedIn, isAdmin, checkingStatus };
}
